module.exports = __webpack_public_path__ + "img/eye.96805532.svg";